import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { BRAND } from "../../constants/brand";

const KEY = "ep_signup_popup_seen";

export default function SignupPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(KEY)) return;
    // don't show on auth/dashboard routes
    const path = window.location.pathname;
    if (path.startsWith("/login") || path.startsWith("/signup") || path.startsWith("/auth") || path.startsWith("/customer") || path.startsWith("/vendor/dashboard")) return;
    const t = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  const goGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={dismiss} data-testid="signup-popup-backdrop">
      <div className="relative w-full max-w-md rounded-xl border border-neutral-200 bg-white p-6 shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="signup-popup">
        <button className="absolute right-4 top-4 rounded-full p-1 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-900" onClick={dismiss} aria-label="Close" data-testid="signup-popup-close">
          <X size={18} />
        </button>
        <img src={BRAND.logo} alt="EarlyPrint" className="mx-auto h-14 w-14 rounded-full" />
        <h3 className="mt-3 text-center font-display text-2xl font-bold">Print anything. From anywhere.</h3>
        <p className="mt-2 text-center text-sm text-neutral-600">Join in one tap — get live quotes from verified vendors in Delhi NCR.</p>
        <button
          onClick={goGoogle}
          className="mt-5 flex w-full items-center justify-center gap-2 rounded-md border border-neutral-300 bg-white px-4 py-3 text-sm font-semibold text-neutral-900 hover:bg-neutral-50"
          data-testid="popup-google-btn"
        >
          <GoogleG /> Continue with Google
        </button>
        <div className="my-3 flex items-center gap-3 text-xs text-neutral-400">
          <div className="h-px flex-1 bg-neutral-200" /> or <div className="h-px flex-1 bg-neutral-200" />
        </div>
        <Link
          to="/signup"
          onClick={dismiss}
          className="btn-offset block w-full rounded-md bg-lime-400 px-4 py-3 text-center text-sm font-bold text-neutral-950 hover:bg-lime-300"
          data-testid="popup-signup-btn"
        >
          Sign up with Email
        </Link>
        <button onClick={dismiss} className="mt-3 w-full text-xs text-neutral-500 hover:text-neutral-900" data-testid="popup-dismiss">
          Just browsing
        </button>
      </div>
    </div>
  );
}

export function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.7 4.8-6.2 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 8 3l5.7-5.7C33.9 6.1 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.6 19 12 24 12c3 0 5.8 1.1 8 3l5.7-5.7C33.9 6.1 29.2 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 44c5.2 0 9.8-2 13.3-5.2l-6.1-5c-2 1.4-4.5 2.2-7.2 2.2-5.1 0-9.5-3.2-11.2-7.9l-6.5 5C9.4 39.5 16.1 44 24 44z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.8l6.1 5C41.6 34.9 44 30 44 24c0-1.3-.1-2.4-.4-3.5z"/>
    </svg>
  );
}
